import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { segmentScreeningConfigurationApi } from '../../../apis';
import { InternalApiEntityGroupScreeningConfiguration } from '../../../api-internal';
import { useMe } from '../../../organisation/useMe';

export const useQuerySegmentScreeningConfiguration = () => {
  const { currentOrganisation } = useMe();

  return useQuery({
    queryKey: ['entity_group_screening_configuration', currentOrganisation?.id],
    queryFn: () => segmentScreeningConfigurationApi.findConfigurations(),
  });
};

export const useUpdateSegmentScreeningConfiguration = () => {
  const queryClient = useQueryClient();
  const { currentOrganisation } = useMe();

  return useMutation({
    mutationFn: (configuration: InternalApiEntityGroupScreeningConfiguration[]) =>
      segmentScreeningConfigurationApi.updateExcludedFromDailyScreening({
        internalApiEntityGroupScreeningConfiguration: configuration,
      }),
    onSuccess: (configuration) => {
      queryClient.setQueryData(['entity_group_screening_configuration', currentOrganisation?.id], configuration);
    },
  });
};
